import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M25.533 5a20.8 20.8 0 0 0-8.783 1.973v3.31a6 6 0 0 1 3.75 1.974 5.96 5.96 0 0 1 0 7.904 6 6 0 0 1-3.75 1.974V27a22.3 22.3 0 0 1 8.782-1.823H28V5zM10 16.21a5.97 5.97 0 0 1 1.503-3.95 6 6 0 0 1 3.747-1.977v-3.31A20.8 20.8 0 0 0 6.467 5H4v20.177h2.467c3.022.007 6.01.628 8.783 1.823v-4.865a6 6 0 0 1-3.747-1.976A5.97 5.97 0 0 1 10 16.21"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 20.942c2.577 0 4.667-2.082 4.667-4.65s-2.09-4.65-4.667-4.65-4.667 2.082-4.667 4.65 2.09 4.65 4.667 4.65m-2-5.465c.032-1.069.832-1.842 1.96-1.842 1.064 0 1.824.678 1.824 1.634 0 .846-.48 1.22-.896 1.545-.323.251-.608.474-.608.863h-.896c0-.806.444-1.142.838-1.441.317-.24.602-.456.602-.871 0-.486-.368-.821-.896-.821-.592 0-1 .422-1.016 1.02zm2.472 3.292a.603.603 0 0 1-.616.605.61.61 0 0 1-.616-.605c0-.343.272-.606.616-.606.352 0 .616.263.616.606",
      clipRule: "evenodd"
    }
  )
);
var SvgDocumentationFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DocumentationFilled_default = SvgDocumentationFilled;

export { DocumentationFilled_default as default };
